import DialogContent from '@mui/material/DialogContent';
import Skeleton from '@mui/material/Skeleton';
import Stack from '@mui/material/Stack';

/** Placeholder rows that mirror the API keys table layout. */
const TableRowSkeleton = () => (
  <Stack direction="row" spacing={2} alignItems="center">
    <Skeleton variant="text" width="18%" height={24} />
    <Skeleton variant="text" width="22%" height={24} />
    <Skeleton variant="text" width="20%" height={24} />
    <Skeleton variant="text" width="20%" height={24} />
    <Skeleton variant="circular" width={24} height={24} sx={{ ml: 'auto' }} />
  </Stack>
);

/**
 * Loading state for the Manage API Keys list view – keeps the modal layout
 * stable while keys and the gateway endpoint are being fetched.
 */
const ManageApiKeysListSkeleton = () => (
  <Stack data-testid="manage-api-keys-loading">
    <Stack spacing={2} sx={{ px: 3, pt: 2 }}>
      <Stack direction="row" justifyContent="space-between" alignItems="center">
        <Skeleton variant="text" width="45%" height={32} />
        <Skeleton variant="circular" width={32} height={32} />
      </Stack>
      <Skeleton variant="text" width="75%" height={20} />
    </Stack>

    <DialogContent>
      <Stack spacing={2} sx={{ pt: 1 }}>
        <Stack spacing={2}>
          <Skeleton variant="text" width="35%" height={24} />
          <Skeleton variant="text" width="100%" height={20} />
          <Stack direction="row" spacing={1}>
            <Skeleton variant="rounded" height={40} sx={{ flexGrow: 1 }} />
            <Skeleton variant="rounded" width={88} height={40} />
          </Stack>
        </Stack>

        <Stack direction="row" justifyContent="flex-end">
          <Skeleton variant="rounded" width={140} height={36} />
        </Stack>

        <Stack spacing={1.5}>
          <Stack direction="row" spacing={2}>
            <Skeleton variant="text" width="18%" height={20} />
            <Skeleton variant="text" width="22%" height={20} />
            <Skeleton variant="text" width="20%" height={20} />
            <Skeleton variant="text" width="20%" height={20} />
          </Stack>
          <TableRowSkeleton />
          <TableRowSkeleton />
          <TableRowSkeleton />
        </Stack>
      </Stack>
    </DialogContent>
  </Stack>
);

export default ManageApiKeysListSkeleton;
